import { render, staticRenderFns } from "./CardPlaceHolder.vue?vue&type=template&id=3d822644&scoped=true&"
import script from "./CardPlaceHolder.vue?vue&type=script&lang=js&"
export * from "./CardPlaceHolder.vue?vue&type=script&lang=js&"
import style0 from "./CardPlaceHolder.vue?vue&type=style&index=0&id=3d822644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d822644",
  null
  
)

export default component.exports